/* eslint-disable*/
/* eslint-disable import/extensions */
/* eslint-disable import/no-unresolved */
/* eslint-disable import/no-extraneous-dependencies */
import React, { useEffect, useState } from 'react';
import { IPage } from 'src/interfaces';
import { useTypedSelector } from 'src/hooks/useTypedSelector';
import { useTranslation } from 'react-i18next';
import paymentsService from 'src/services/payments.service';
import { AlertAdapter, HorizonDropdown } from 'pg-ui-library';
import { useNavigate } from 'react-router-dom';
import Chatbot from '../chatbot/index';
import { pieArcLabelClasses, PieChart } from '@mui/x-charts/PieChart';
import { NotificationsTable } from 'src/components';
import {
  BenefitsContainer,
  Container,
  HeaderText,
  PayHistoryColumnContainer,
  Borderline,
  PichartContainer,
  PayHistoryContainer,
  PayHistoryRedirectButton,
  PaystubText,
  ReceiptIcon,
  RightContainer,
  RecentPaystub,
  SubHeaderText,
  Overlay,
  MainNotification,
  BenefitsallButton,
} from './styles';
import BenefitsTable from '../benefits/components/benefits-table';

const Dashboard: React.FC<IPage> = () => {
  const { t } = useTranslation();
  const { data } = useTypedSelector(state => state.notifications);
  const navigate = useNavigate();
  const [paystubsData, setPaystubsData] = useState<{ [key: string]: number }>({});
  const [paymentsSummaryData, setPaymentsSummaryData] = useState<any>(null);
  const [selectedYear, setSelectedYear] = useState<string>(new Date().getFullYear().toString());

  const currentYear = new Date().getFullYear();
  const yearOptions = Array.from({ length: 3 }, (_, i) => {
    const year = currentYear - i;
    return { key: year.toString(), label: year.toString(), value: year.toString() };
  });

  useEffect(() => {
    const fetchData = async () => {
      try {
        const paystubsResponse = await paymentsService.getPaystubsRange();
        setPaystubsData(paystubsResponse.data);

        const summaryResponse = await paymentsService.getPaymentsSummary();
        setPaymentsSummaryData(summaryResponse.data);
      } catch (error) {
        const errorMessage = (error as Error).message || 'An unknown error occurred';
        AlertAdapter(`Error fetching data: ${errorMessage}`, 'error');
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
    const fetchSummaryByYear = async () => {
      try {
        const summaryResponse = await paymentsService.getPaymentsSummaryByYear(selectedYear);
        setPaymentsSummaryData(summaryResponse.data);
      } catch (error) {
        const errorMessage = (error as Error).message || 'An unknown error occurred';
        AlertAdapter(`Error fetching data for year ${selectedYear}: ${errorMessage}`, 'error');
      }
    };

    fetchSummaryByYear();
  }, [selectedYear]);

  useEffect(() => {
    const fetchPaystubsByYear = async () => {
      try {
        const paystubsResponse = await paymentsService.getPaystubsByYear(selectedYear);
        setPaystubsData(paystubsResponse.data);
      } catch (error) {
        const errorMessage = (error as Error).message || 'An unknown error occurred';
        AlertAdapter(`Error fetching paystubs for year ${selectedYear}: ${errorMessage}`, 'error');
      }
    };

    fetchPaystubsByYear();
  }, [selectedYear]);

  const paystubsYears = Object.keys(paystubsData).slice(-3);
  const paystubsCounts = Object.values(paystubsData).slice(-3);

  const colorsForYears = ['#F7931E', '#39B54A', '#0071BC'];
  const summaryLabels = ['Taxes', 'Deductions', 'Net Pay'];
  const summaryValues = [
    paymentsSummaryData ? paymentsSummaryData.percentages?.taxes?.toFixed(2) : '0.00',
    paymentsSummaryData ? paymentsSummaryData.percentages?.deductions?.toFixed(2) : '0.00',
    paymentsSummaryData ? paymentsSummaryData.percentages?.netPay?.toFixed(2) : '0.00',
  ];

  const colorsForSummary = ['#3B85F7', '#39B54A', '#EC2DFC', '#F7931E'];

  return (
    <Overlay>
      <Container>
        <PayHistoryContainer>
          <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
            <HeaderText style={{ flex: 1, fontSize: '20px', textAlign: 'center', marginLeft: '-182px' }}>
              <p style={{ marginLeft: '103px', marginTop: '-1.5px' }}>{t('dashboard.payHistory.title')}</p>
            </HeaderText>
            <HeaderText style={{ flex: 1, fontSize: '18px', textAlign: 'center' }}>
              <p style={{ marginLeft: '187px', marginTop: '1.5px' }}>Historical Pay Count</p>
            </HeaderText>
            <HeaderText style={{ flex: 1, fontSize: '18px', textAlign: 'center' }}>
              Pay Allocation Summary
              <div
                style={{
                  marginLeft: '470px',
                  marginTop: '-29px',
                  color: '#9399B2',
                  font: 'Biotif-SemiBold',
                  fontSize: '10px',
                }}
              >
                <HorizonDropdown
                  label="Year Filter"
                  options={yearOptions}
                  setValue={(year: string) => {
                    setSelectedYear(year);
                  }}
                />
              </div>
            </HeaderText>
          </div>

          <PayHistoryColumnContainer>
            <RecentPaystub>
              <ReceiptIcon />
              <div style={{ width: 'max-content', marginLeft: '53px', marginTop: '9px', color: 'white' }}>
                Your most
              </div>
              <div style={{ width: 'max-content', marginLeft: '28px', color: 'white' }}>Recent PayStub</div>
              <PayHistoryRedirectButton target="_blank" to={paymentsService.getLatestPayStubs() as unknown as ''}>
                <PaystubText style={{ marginRight: '15px', marginTop: '10px', width: '90px', marginLeft: '22px' }}>
                  Download
                </PaystubText>
              </PayHistoryRedirectButton>
              <PayHistoryRedirectButton
                target="_blank"
                to="/pay-history"
                style={{ marginTop: '20px', width: '145px', marginLeft: '24px' }}
              >
                <PaystubText style={{ marginRight: '15px', width: '126px' }}>View All Paystubs</PaystubText>
              </PayHistoryRedirectButton>
            </RecentPaystub>

            <PichartContainer style={{ display: 'flex', justifyContent: 'space-around' }}>
              <Borderline>
                <PieChart
                  series={[
                    {
                      data: paystubsYears.map((year, index) => ({
                        id: index,
                        value: paystubsCounts[index],
                        label: year,
                      })),
                      arcLabel: item => `${item.value}`,
                      arcLabelMinAngle: 35,
                      arcLabelRadius: '60%',
                    },
                  ]}
                  sx={{
                    [`& .${pieArcLabelClasses.root}`]: {
                      fontWeight: 'bold',
                      fill: 'white',
                      fontSize: '14px',
                    },
                  }}
                  width={400}
                  height={200}
                  colors={colorsForYears}
                />
              </Borderline>

              <Borderline>
                <PieChart
                  series={[
                    {
                      data: summaryLabels.map((label, index) => ({
                        id: index,
                        value: summaryValues[index],
                        label,
                      })),
                      arcLabel: item => `${item.value}%`,
                      arcLabelMinAngle: 35,
                      arcLabelRadius: '60%',
                    },
                  ]}
                  sx={{
                    [`& .${pieArcLabelClasses.root}`]: {
                      fontWeight: 'bold',
                      fill: 'white',
                      fontSize: '14px',
                    },
                  }}
                  width={400}
                  height={200}
                  colors={colorsForSummary}
                />
              </Borderline>
            </PichartContainer>
          </PayHistoryColumnContainer>
        </PayHistoryContainer>

        <div style={{ display: 'flex' }}>
          <BenefitsContainer style={{ flex: 1, marginRight: '10px' }}>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
              <HeaderText>{t('dashboard.benefits.title')}</HeaderText>
              <BenefitsallButton onClick={() => navigate('/benefits', { replace: false })}>
                {t('global.button.viewAll')}
              </BenefitsallButton>
            </div>
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <SubHeaderText style={{ marginLeft: '1px', marginTop: '5px', fontSize: '18px' }}>
                {t('dashboard.benefits.listTitle')}
              </SubHeaderText>
            </div>
            <BenefitsTable />
          </BenefitsContainer>

          <RightContainer>
            <MainNotification>
              <NotificationsTable tableData={data.notifications} />
            </MainNotification>
          </RightContainer>
        </div>
      </Container>
      <div
        style={{
          position: 'fixed',
          bottom: 40,
          right: 40,
          zIndex: 9999,
        }}
      >
        <Chatbot userId="" chatId="" />
      </div>
    </Overlay>
  );
};

export default Dashboard;
